
function stat_modifier(number) {
    return Math.floor(parseInt(number)/2) - 5;
}

export default stat_modifier;
